module.exports = __webpack_public_path__ + "static/media/background1.d3d73603.png";